<template>
    <div class="modal is-active">
        <div class="modal-background" />
        <div class="modal-card">
            <header class="modal-card-head is-block">
                <nav class="box level">
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="title">
                                <span class="icon">
                                    <i class="fas fa-stopwatch" />
                                </span>
                            </p>
                            <p class="title">
                                {{ session.configuration.time }}
                                {{ session.configuration.timeUnits }}
                            </p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="title">
                                <span class="icon">
                                    <i class="fas fa-question" />
                                </span>
                            </p>
                            <p class="title">
                                {{ session.context.length }}
                            </p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="title">
                                <span class="icon">
                                    <i class="fas fa-key" />
                                </span>
                            </p>
                            <p class="title">
                                {{ session.shortCode }}
                            </p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="title">
                                <span class="icon">
                                    <i class="fas fa-users" />
                                </span>
                            </p>
                            <p class="title">
                                {{ session.participants.length }}
                            </p>
                        </div>
                    </div>
                </nav>

                <div class="field has-addons">
                    <p class="control is-expanded">
                        <input
                            :value="shareSessionURL"
                            readonly
                            class="input"
                            type="text"
                        />
                    </p>
                    <p class="control">
                        <a
                            :class="{
                                'has-tooltip-active': showCopiedTooltip,
                            }"
                            :data-tooltip="
                                $t(
                                    showCopiedTooltip
                                        ? 'Sessions.URLcopied'
                                        : 'Sessions.copyURL'
                                )
                            "
                            class="button is-disabled"
                            @click="copySessionURL"
                        >
                            <span class="icon is-small">
                                <i class="fas fa-clipboard"></i>
                            </span>
                        </a>
                    </p>
                </div>
            </header>
            <section class="modal-card-body">
                <session-ranking />
            </section>
            <footer class="modal-card-foot"></footer>
        </div>
        <router-link
            :to="`/project/${$store.getters.project._id}`"
            class="modal-close is-large"
            aria-label="close"
        />
    </div>
</template>

<script>
import SessionRanking from '@/components/SessionRanking';
import { fetchItem } from '@/services/API';
export default {
    components: {
        SessionRanking,
    },
    data() {
        return {
            updateInterval: null,
            showCopiedTooltip: false,
        };
    },
    computed: {
        session() {
            return this.$store.state.session;
        },
        shareSessionURL() {
            return (
                process.env.VUE_APP_SHARE_SESSION_URL +
                this.session.shortCode +
                '&lang=' +
                this.$i18n.locale
            );
        },
    },
    mounted() {
        this.updateInterval = setInterval(this.fetchSession, 5000);
        this.fetchSession();
    },
    beforeRouteEnters() {
        console.log('hereeee', this.$store);
        if (!this.$store.state.session) {
            this.$router.push({
                name: 'project',
                params: { projectId: this.$route.params.projectId },
            });
        }
    },
    beforeDestroy() {
        clearInterval(this.updateInterval);
        this.$store.dispatch('cleanSession');
    },
    methods: {
        async fetchSession() {
            let session = await fetchItem(
                'session',
                this.$store.state.session._id
            );
            this.$store.dispatch('setSession', session.data);
        },
        copySessionURL() {
            this.$copyText(this.shareSessionURL).then((e) => {
                this.showCopiedTooltip = true;
                setTimeout(() => {
                    this.showCopiedTooltip = false;
                }, 1500);
            });
        },
    },
};
</script>

<style scoped>
.is-static {
    border-color: unset;
}
</style>
